/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=60a13bc3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=60a13bc3&lang=css"

import exportComponent from "C:\\Users\\Administrator\\IdeaProjects\\haoma517-cust\\haoma517-customer-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__